import api from '../../../../api';

export const ContentSelector = {
  CONTENT: api.internals.ns.selector('content-media'),
  IMG: api.internals.ns.selector('content-media__img')
};
